<template>
  <div class="setting-item">
    <label class="setting-label">{{ label }}</label>
    <div class="setting-value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemSetting',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .setting-label {
    min-width: 80px;
    font-size: 14px;
    color: #606266;
    margin-right: 16px;
  }

  .setting-value {
    flex: 1;
  }
}
</style>
